import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from '@angular/core';
import { AuthService } from "auth";
import { I18nService } from "i18n";
import { Conference } from 'calendar';
import { lastValueFrom } from 'rxjs';
import { ENVIRONMENT, Logger } from 'shared';

export type Signature = {
  signature: string;
  sdkKey: string;
}

@Injectable({
  providedIn: 'root'
})
export class ZoomService {

  private signatureEndpoint = '/conference/zoom/signature';

  protected logger = new Logger('ZoomService');

  constructor(private httpClient: HttpClient,
    private i18nService: I18nService,
    private authService: AuthService,
    @Inject(ENVIRONMENT) private environment: any) { }

  async getSignature(conference: Conference): Promise<Signature> {
    const { room_name, hostId } = { ...conference?.properties };
    const payload = {
      meetingNumber: room_name,
      role: hostId == this.authService.getUser()?.id ? 1 : 0
    }
    try {
      const response = await lastValueFrom(
        this.httpClient.post<Signature>(
          this.signatureEndpoint,
          payload
        )
      );
      if (!response?.signature) {
        throw new Error('No signature received from server');
      }
      return response;
    } catch (error) {
      this.logger.error('Failed to get Zoom signature:', error);
      throw new Error('Failed to get meeting signature');
    }
  }
}
